import React from 'react';
import StyledBox from 'views/rebranded-module/information-module/ContactUsViewV2/components/AdditionalInformationSection/AdditionalInformationSection.styles';
import { Container, Grid, Typography } from '@mui/material';
import { Typography700 } from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';

const AdditionalInformationSection: React.FC = () => {
    const content = useContent('ContactUsPage');
    const links = [
        { id: 1, ref: 'damage-waiver', label: content.damageWaiverLink, path: PATHS.insurance().url },
        {
            id: 2,
            ref: 'driver-license-requirements',
            label: content.driverLicenseRequirementsLink,
            path: PATHS.driverLicense().url,
        },
        { id: 3, ref: 'faqs', label: content.faqsLink, path: PATHS.faqs.index().url },
        {
            id: 4,
            ref: 'payment-options',
            label: content.paymentOptionsLink,
            path: PATHS.paymentOptions().url,
        },
        {
            id: 5,
            ref: 'rental-terms',
            label: content.rentalTermsLink,
            path: PATHS.rentals.rentalTerms().url,
        },
        {
            id: 6,
            ref: 'guided-tours-terms',
            label: content.guidedToursTermsLink,
            path: PATHS.tour.guidedTourTerms().url,
        },
        {
            id: 7,
            ref: 'self-guided-terms',
            label: content.selfGuidedTermsLink,
            path: PATHS.tour.selfDriveTourTerms().url,
        },
        {
            id: 8,
            ref: 'off-road-terms',
            label: content.offRoadTermsLink,
            path: PATHS.tour.offRoadTourTerms().url,
        },
        {
            id: 9,
            ref: 'membership-terms',
            label: content.membershipTermsLink,
            path: PATHS.membership.termsAndConditions().url,
        }
    ];

    // Function to chunk the links into columns
    const chunkLinks = (arr: any[], size: number) => Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
    // Split links into 3 columns (3 links each)
    const columns = chunkLinks(links, 3);

    return (
        <StyledBox>
            <Container maxWidth="xxl" className="NBContainer">
                <Typography700 variant="h6" my={2} className="NBAdditionalInformationTitle">
                    {content.additionalInformationTitle}
                </Typography700>
                <Grid container spacing={5}>
                    {columns.map((column) => (
                        <Grid item md={4} sm={12} key={column[0]?.id}>
                            {column.map((link) => (
                                <Typography variant="body3" component="p" my={1} key={link.id}>
                                    <NavigatorLink className="NBLogoLink" href={link.path} data-ref={link.ref}>
                                        {link.label}
                                    </NavigatorLink>
                                </Typography>
                            ))}
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </StyledBox>
    );
};

export { AdditionalInformationSection };

